import { useContractModalCta } from '#src/app/pages/ambassadors/landing/shared/hooks';

type Result = ModelHookResult<
	undefined,
	{
		handleCtaClick: () => void;
	}
>;

export function useFooterCta(): Result {
	return {
		actions: {
			handleCtaClick: useContractModalCta('footer'),
		},
	};
}
